import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-screen h-screen bg-[#00000061] fixed z-50 top-0 left-0" }
const _hoisted_2 = { class: "pb-0 w-full" }
const _hoisted_3 = { class: "w-full flex flex-col gap-4" }
const _hoisted_4 = { class: "flex items-center gap-8" }
const _hoisted_5 = ["for"]
const _hoisted_6 = { class: "mt-8 flex w-ful justify-center items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_ImportCSV = _resolveComponent("ImportCSV")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Dialog, {
      visible: _ctx.showImportModal,
      "onUpdate:visible": [
        _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showImportModal) = $event)),
        _ctx.onCloseImportModal
      ],
      draggable: false,
      breakpoints: { '960px': '95vw', '640px': '95vw' },
      style: { width: '40vw', minWidth: '360px' },
      modal: true,
      contentStyle: "",
      class: "dialog"
    }, {
      header: _withCtx(() => [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: `Importar alunos`,
                en: `Import students`,
              })), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("section", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.radios, (item, i) => {
                return (_openBlock(), _createElementBlock("div", { key: i }, [
                  _createVNode(_component_RadioButton, {
                    id: item.name,
                    modelValue: _ctx.importType,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.importType) = $event)),
                    inputId: `id-${item.name}`,
                    value: item.value,
                    name: "radio-listed",
                    class: "custom-radio"
                  }, null, 8, ["id", "modelValue", "inputId", "value"]),
                  _createElementVNode("label", {
                    for: `id-${item.name}`,
                    class: _normalizeClass(['font-bold ml-3 cursor-pointer'])
                  }, _toDisplayString(item.name), 9, _hoisted_5)
                ]))
              }), 128))
            ]),
            _createVNode(_component_AutoComplete, {
              id: "values-input",
              modelValue: _ctx.currentValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentValue) = $event)),
              suggestions: _ctx.items,
              forceSelection: true,
              onComplete: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchFor($event))),
              optionLabel: "name",
              placeholder: _ctx.importType ? 'Escolha o curso' : 'Escolha a turma',
              class: _normalizeClass(`w-full`)
            }, null, 8, ["modelValue", "suggestions", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_ImportCSV, {
              id: "import-user-btn",
              onOnUpload: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onUpload($event))),
              onOnDownload: _ctx.downloadCSV,
              showErrors: true,
              data: _ctx.importData,
              openModal: _ctx.displayModal,
              btnStyle: "btn-primary w-full",
              btnIcon: "md-uploadfile-round",
              btnDisabled: _ctx.currentValue?.id ? false : true,
              buttons: {
              first: _ctx.$t('labels.generic', {
                pt: 'Selecionar arquivo',
                en: 'Select file',
              }),
              second: _ctx.$t('labels.generic', {
                pt: 'Importar novo documento',
                en: 'Import new document',
              }),
            }
            }, null, 8, ["onOnDownload", "data", "openModal", "btnDisabled", "buttons"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onUpdate:visible"])
  ]))
}